module.exports = __webpack_public_path__ + "img/cb14582.png";